import { useState, useEffect } from "react";
import {
  Button,
  TextField,
  Box,
  Typography,
  Paper,
  IconButton,
  InputAdornment,
  CircularProgress,
} from "@mui/material";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useNavigate, Link } from 'react-router-dom';
import api from '../../services/api.js';

export default function Login() {
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [empresa, setEmpresa] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchEmpresa = async () => {
      try {
        const res = await api.get(`/empresa/public?t=${new Date().getTime()}`);
        if (res.data?.dados) {
          setEmpresa(res.data.dados);
        }
      } catch (err) {
        console.error("Erro ao carregar logo da empresa:", err);
      }
    };
    fetchEmpresa();
  }, []);

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleLogin = async () => {
    setError("");
    setLoading(true);

    if (!email || !senha) {
      setError("Preencha o e-mail e a senha corretamente.");
      setLoading(false);
      return;
    }

    try {
      const res = await api.post('/auth/login', {
        st_email: email.trim().toLowerCase(),
        st_senha: senha,
      });

      const data = res.data;

      localStorage.setItem("token", data.token);
      localStorage.setItem("refreshToken", data.refreshToken);
      localStorage.setItem("usuario", JSON.stringify(data.usuario));

      // ✅ Redirecionar para a página principal
      window.location.href = "/cockpit";
    } catch (err) {
      console.error("Erro de conexão:", err);
      if (err.response?.data?.error) {
        setError(err.response.data.error);
      } else {
        setError("Erro de conexão. Verifique sua internet e tente novamente.");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    handleLogin();
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#000000',
        padding: 2,
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: 'url(/fundo_login.png?v=6)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          opacity: 0.5,
          zIndex: 0,
        }}
      />
      <Paper
        elevation={8}
        sx={{
          position: 'relative',
          zIndex: 1,
          padding: 4,
          borderRadius: 3,
          maxWidth: 400,
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Box
          component="img"
          src="/logo_empresa.png"
          alt="Logo da Empresa"
          sx={{
            width: 180,
            height: 180,
            objectFit: 'contain',
            mb: 2
          }}
        />
        <Typography variant="h5" component="h1" gutterBottom>
          GestCard
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Bem-vindo de volta! Faça login para continuar.
        </Typography>

        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ width: '100%' }}>
          <TextField
            margin="normal"
            fullWidth
            id="email"
            label="E-mail"
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            error={!!error}
            disabled={loading}
          />
          <TextField
            margin="normal"
            fullWidth
            name="password"
            label="Senha"
            type={showPassword ? 'text' : 'password'}
            id="password"
            autoComplete="current-password"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            error={!!error}
            helperText={error}
            disabled={loading}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="alternar visibilidade da senha"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                    disabled={loading}
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            sx={{ mt: 3, mb: 2, py: 1.5, bgcolor: '#20ac9c', '&:hover': { bgcolor: '#167a6f' } }}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : 'Entrar'}
          </Button>
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
            <Link to="/forgot-password" style={{ color: '#20ac9c', textDecoration: 'none' }}>
              Esqueceu a senha?
            </Link>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
}


